const locale = {
  COMMON: {
    TXT_TITLE: 'EnOS Documentation',
    TXT_DESCRIPTION: 'EnOS documentation helps you gain a comprehensive understanding of EnOS products and services.',
    TXT_TUTORIAL_TITLE: 'EnOS Quickstarts and Tutorials',
    TXT_TUTORIAL_DESCRIPTION: 'Explore step-by-step walkthroughs of core scenarios to quickly get started with EnOS.',
    BTN_LAN_SWITCH: 'Switch Language',
    TXT_DOCUMENTATION: 'Documentation',
    TXT_VERSION: 'Version',
    TXT_LANG: 'Language',
    TXT_ENOS_LINK_HINT1: 'Visit',
    TXT_ENOS_LINK_HINT2: 'EnOS Developer Center',
    TXT_ENOS_LINK_HINT3: 'to obtain the latest documentation for all active releases and other development resources.',
    TXT_COPY_RIGHT: '© {0} Univers. All Rights Reserved.',
    HINT_NEED_LOGIN: 'Please Login First',
    TITLE_WRONG_MESSAGE: 'Wrong Message',
    TXT_VERSION_TITLE: 'Version Information',
    TXT_LEARN_MORE: '  Learn more',
    PAGE_NOT_FOUND: 'Page not found',
    PAGE_NOT_FOUND_DETAIL: 'The URL might have been changed or the page does not exist. ',
    NOT_FOUND_TIP: 'Automatically turn on after seconds',
    HOME_PAGE: 'home page',
    CHINESE: 'Simplified Chinese',
    ENGLISH: 'English',
    SEARCH_DOCUMENT: 'Search EnOS documentation',
    TXT_ALL_PRODUCTS: 'All Products',
    CONTACT_US: 'Report Vulnerabilities',
    GLOBAL_SEARCH_PLACEHOLDER: 'Search this global'
  },
  GLOBAL_SEARCH: {
    SEARCHING: 'Searching...',
    SEARCH_RESULT: 'Search Results',
    SEARCH_NO_RESULT: 'No Results',
    SEARCH_RESULT_DATA: 'Search finished, found {0} page(s) for "{1}".',
    SEARCH_NO_RESULT_DATA: 'Your search did not match any documents.',
    SEARCH: 'Search',
    FILTER: 'Filter',
    PROJECT_NAME: 'Product Documentation',
    VERSION_NAME: 'Version',
    ALL_VERSION: 'All Versions',
    GO_BACK: 'Go Back',
    FILTER_PRODUCE: 'Search product name'
  }
};

export default locale;
